import * as ambassadorWixBookingsCatalogSearchV1CatalogSearch from './bookings-catalog-search-v1-catalog-search-catalog-search.http.js';
import * as ambassadorWixBookingsCatalogSearchV1CatalogSearchTypes from './bookings-catalog-search-v1-catalog-search-catalog-search.types.js';
import * as ambassadorWixBookingsCatalogSearchV1CatalogSearchUniversalTypes from './bookings-catalog-search-v1-catalog-search-catalog-search.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryServicesByFilters(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsCatalogSearchV1CatalogSearchUniversalTypes.QueryServicesByFiltersRequest,
  ambassadorWixBookingsCatalogSearchV1CatalogSearchTypes.QueryServicesByFiltersRequest,
  ambassadorWixBookingsCatalogSearchV1CatalogSearchUniversalTypes.QueryServicesByFiltersResponse,
  ambassadorWixBookingsCatalogSearchV1CatalogSearchTypes.QueryServicesByFiltersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsCatalogSearchV1CatalogSearch.queryServicesByFilters(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/catalog/search/services/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CatalogSearchResult as CatalogSearchResultOriginal,
  QueryServicesByFiltersRequest as QueryServicesByFiltersRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  ServiceFilters as ServiceFiltersOriginal,
  Attribute as AttributeOriginal,
  AttributeValueOneOf as AttributeValueOneOfOriginal,
  NumberRange as NumberRangeOriginal,
  NumberValues as NumberValuesOriginal,
  QueryServicesByFiltersResponse as QueryServicesByFiltersResponseOriginal,
  ServiceWithAvailability as ServiceWithAvailabilityOriginal,
  Service as ServiceOriginal,
  ServiceType as ServiceTypeOriginal,
  ServiceTypeWithLiterals as ServiceTypeWithLiteralsOriginal,
  Media as MediaOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemItemOneOf as MediaItemItemOneOfOriginal,
  Image as ImageOriginal,
  Category as CategoryOriginal,
  Form as FormOriginal,
  FormSettings as FormSettingsOriginal,
  Payment as PaymentOriginal,
  PaymentRateOneOf as PaymentRateOneOfOriginal,
  RateType as RateTypeOriginal,
  RateTypeWithLiterals as RateTypeWithLiteralsOriginal,
  FixedPayment as FixedPaymentOriginal,
  Money as MoneyOriginal,
  DepositDetails as DepositDetailsOriginal,
  DepositDetailsValueOneOf as DepositDetailsValueOneOfOriginal,
  CustomPayment as CustomPaymentOriginal,
  VariedPayment as VariedPaymentOriginal,
  SubscriptionPayment as SubscriptionPaymentOriginal,
  FrequencyType as FrequencyTypeOriginal,
  FrequencyTypeWithLiterals as FrequencyTypeWithLiteralsOriginal,
  FirstChargeDateType as FirstChargeDateTypeOriginal,
  FirstChargeDateTypeWithLiterals as FirstChargeDateTypeWithLiteralsOriginal,
  FullUpfrontPayment as FullUpfrontPaymentOriginal,
  PaymentOptions as PaymentOptionsOriginal,
  AddOnPaymentOptions as AddOnPaymentOptionsOriginal,
  AddOnPaymentOptionsWithLiterals as AddOnPaymentOptionsWithLiteralsOriginal,
  DiscountInfo as DiscountInfoOriginal,
  OnlineBooking as OnlineBookingOriginal,
  Conferencing as ConferencingOriginal,
  Location as LocationOriginal,
  LocationOptionsOneOf as LocationOptionsOneOfOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  BusinessLocationOptions as BusinessLocationOptionsOriginal,
  CustomLocationOptions as CustomLocationOptionsOriginal,
  BookingPolicy as BookingPolicyOriginal,
  PolicyDescription as PolicyDescriptionOriginal,
  LimitEarlyBookingPolicy as LimitEarlyBookingPolicyOriginal,
  LimitLateBookingPolicy as LimitLateBookingPolicyOriginal,
  BookAfterStartPolicy as BookAfterStartPolicyOriginal,
  CancellationPolicy as CancellationPolicyOriginal,
  ReschedulePolicy as ReschedulePolicyOriginal,
  WaitlistPolicy as WaitlistPolicyOriginal,
  ParticipantsPolicy as ParticipantsPolicyOriginal,
  ResourcesPolicy as ResourcesPolicyOriginal,
  CancellationFeePolicy as CancellationFeePolicyOriginal,
  CancellationWindow as CancellationWindowOriginal,
  CancellationWindowFeeOneOf as CancellationWindowFeeOneOfOriginal,
  SaveCreditCardPolicy as SaveCreditCardPolicyOriginal,
  StaffSortingPolicy as StaffSortingPolicyOriginal,
  StaffSortingPolicyOptionsOneOf as StaffSortingPolicyOptionsOneOfOriginal,
  RankingOrder as RankingOrderOriginal,
  RankingOrderWithLiterals as RankingOrderWithLiteralsOriginal,
  SortingMethodType as SortingMethodTypeOriginal,
  SortingMethodTypeWithLiterals as SortingMethodTypeWithLiteralsOriginal,
  RankingOptions as RankingOptionsOriginal,
  CustomOptions as CustomOptionsOriginal,
  IntakeFormPolicy as IntakeFormPolicyOriginal,
  Timing as TimingOriginal,
  TimingWithLiterals as TimingWithLiteralsOriginal,
  CompletionRequirement as CompletionRequirementOriginal,
  CompletionRequirementWithLiterals as CompletionRequirementWithLiteralsOriginal,
  LimitRebookingPolicy as LimitRebookingPolicyOriginal,
  Schedule as ScheduleOriginal,
  AvailabilityConstraints as AvailabilityConstraintsOriginal,
  Duration as DurationOriginal,
  DurationRange as DurationRangeOriginal,
  DurationRangeConfigOneOf as DurationRangeConfigOneOfOriginal,
  UnitType as UnitTypeOriginal,
  UnitTypeWithLiterals as UnitTypeWithLiteralsOriginal,
  HourlyConfig as HourlyConfigOriginal,
  DailyConfig as DailyConfigOriginal,
  WorkingHours as WorkingHoursOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  StaffMember as StaffMemberOriginal,
  StaffMediaItem as StaffMediaItemOriginal,
  StaffMediaItemItemOneOf as StaffMediaItemItemOneOfOriginal,
  WorkingHoursLocationCoverage as WorkingHoursLocationCoverageOriginal,
  StaffMemberDetails as StaffMemberDetailsOriginal,
  ResourceGroup as ResourceGroupOriginal,
  ResourceIds as ResourceIdsOriginal,
  ServiceResource as ServiceResourceOriginal,
  ServiceResourceSelectionOneOf as ServiceResourceSelectionOneOfOriginal,
  ResourceType as ResourceTypeOriginal,
  ResourceDetails as ResourceDetailsOriginal,
  ResourceInfo as ResourceInfoOriginal,
  Slug as SlugOriginal,
  URLs as URLsOriginal,
  PageUrlV2 as PageUrlV2Original,
  ExtendedFields as ExtendedFieldsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  AddOnGroup as AddOnGroupOriginal,
  AddOnDetails as AddOnDetailsOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  PhoneCall as PhoneCallOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
} from './bookings-catalog-search-v1-catalog-search-catalog-search.types.js';
